import { inject, injectable } from "inversify";
import { Organization } from "@/models/organization/organization";
import { SERVICES_TYPES } from "@/ioc/SERVICES_TYPES";
import { HttpClient } from "@/services/client";
import { IOrganizationApi } from "./IOrganizationApi";

@injectable()
export class OrganizationApi implements IOrganizationApi {
  @inject(SERVICES_TYPES.HTTP_CLIENT)
  private client: HttpClient;

  private readonly baseUrl = "/organizations";

  async getAll(query?: string): Promise<Organization[]> {
    const url = query ? `${this.baseUrl}?name=${query}` : this.baseUrl;
    const { data } = await this.client.get<Organization[]>(url);
    return data;
  }
}
